import React from "react";
import {
    Modal,
    Box,
    Typography,
    IconButton,
    Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

const ModalWrapper = ({
    open,
    setOpen,
    onClose,
    title,
    subtitle,
    actions,
    content,
    width = "50vw",
    fullHeight = false,
    scrollWholeModal = false,
}) => {
    const { t } = useTranslation();

    // Default translated values
    const finalTitle = title || t('TITLES.CONFIRM_ACTION');
    const finalSubtitle = subtitle || t('TITLES.REVIEW_DETAILS_AND_CONTINUE');

    const handleClose = () => {
        if (onClose) onClose();
        setOpen(false);
    };

    const isCustomTitle = React.isValidElement(title);

    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "90%", sm: width },
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    borderRadius: 2,
                    p: 2,
                    outline: "none",
                    display: "flex",
                    flexDirection: "column",

                    ...(fullHeight
                        ? {
                              height: "90vh",
                              maxHeight: "90vh",
                              overflowY: scrollWholeModal ? "auto" : "hidden",
                              overflowX: "hidden",
                          }
                        : {
                              maxHeight: "80vh",
                              overflowY: scrollWholeModal ? "auto" : "visible",
                              overflowX: "hidden",
                          }),
                }}
            >
                {/* Header */}
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start"
                    sx={{ flexShrink: 0, mb: 2 }}
                >
                    {isCustomTitle ? (
                        <Box sx={{ flex: 1, mr: 1 }}>{finalTitle}</Box>
                    ) : (
                        <Box>
                            <Typography variant="h6" fontWeight={600}>
                                {finalTitle}
                            </Typography>
                            {subtitle && (
                                <Typography
                                    variant="body2"
                                    fontSize="11px"
                                    color="text.secondary"
                                    sx={{ mt: 0.5 }}
                                >
                                    {finalSubtitle}
                                </Typography>
                            )}
                        </Box>
                    )}
                    <IconButton onClick={handleClose} sx={{ flexShrink: 0, mt: -0.5, mr: -0.5 }}>
                        <CloseIcon />
                    </IconButton>
                </Stack>

                {/* Content */}
                <Box
                    sx={{
                        flexGrow: scrollWholeModal ? 0 : 1,
                        flexShrink: 1,
                        overflowY: scrollWholeModal ? "visible" : "auto",
                        minHeight: scrollWholeModal ? "auto" : 0,
                    }}
                >
                    {content}
                </Box>

                {/* Actions */}
                {actions && (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 1,
                            flexShrink: 0,
                            pt: 2,
                            mt: 2,
                            borderTop: '1px solid',
                            borderColor: 'divider',
                        }}
                    >
                        {actions}
                    </Box>
                )}
            </Box>
        </Modal>
    );
};

export default ModalWrapper;
